import React from "react";
import {
  ContentPlaceHolder,
  ContentPlaceHolderProps,
} from "../ContentPlaceHolder";

/** Useful for minicart item, wishlist item, etc */
export const ContentPlaceHolderPresetListItem: React.FC<ContentPlaceHolderProps> =
  (props) => (
    <ContentPlaceHolder width="400" height="52" viewBox="0 0 400 52" {...props}>
      <rect x="0" y="0" rx="5" ry="5" width="64" height="52" />
      <rect x="80" y="0" rx="4" ry="4" width="250" height="13" />
      <rect x="80" y="20" rx="4" ry="4" width="250" height="13" />
      <rect x="340" y="0" rx="4" ry="4" width="60" height="13" />
    </ContentPlaceHolder>
  );
